import {Component, ElementRef, NgZone, ViewChild} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Events,IonicPage, LoadingController, NavController, NavParams, MenuController} from 'ionic-angular';
import {IonicSelectableComponent} from 'ionic-selectable';
import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {ProofProvider} from '../../providers/proof/proof';
import {AuthProvider} from '../../providers/auth/auth';
import {UploadingProvider} from '../../providers/uploading/uploading';
import {TitleProvider} from '../../providers/title/title';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {ProofServerProvider} from "../../providers/proof-server/proof-server";
import { RegistrationDocument } from '../../models/registrationdocument';
import { FileUploader, FileLikeObject } from  'ng2-file-upload';
import {ProofBeforeBeginPage} from '../proof-before-begin/proof-before-begin';

import * as Config from "../../app/app.config";
import {Titledocument} from "../../models/titledocument";

import {RegistrationPersonal} from '../../models/registrationpersonal';

/**
 * Generated class for the UpdateRegistrationDocumentPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-update-title-document',
  templateUrl: 'update-title-document.html',
})
export class UpdateTitleDocumentPage {

  public fileUploader: FileUploader = new FileUploader({queueLimit: 10});
  public hasBaseDropZoneOver: boolean = false;

  private user: any;
  public proof: any = {};
  private hasApprovedCertification: boolean;
  public registrationDocument: RegistrationDocument;
  public titleDocument: Titledocument;
  public mandatoryDocumentation = '';
  public registrationPersonal: RegistrationPersonal;
  public titleId: any;
  public title: string;
  public buttonContinue: boolean = false;
  private categories: any[] = [];
  private subcategories: any[] = [];
  private interval: any;
  public contractEndDate: string;
  public titles: any[] = [];
  public userFilesGet: any[] = [];
  public remaining: any = null;

  @ViewChild('upload') upload: ElementRef;

  constructor(
    private http: Http,    
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider,
    private uploadingprovider: UploadingProvider,
    private zone: NgZone,
    private proofServerProvider: ProofServerProvider,
    private titleProvider: TitleProvider,
    private menu: MenuController,    
    private proofProvider: ProofProvider,    
    private events: Events,    
  ) {
    this.titleId = 0;
    this.hasApprovedCertification = false;
    this.buttonContinue = navParams.get('buttonContinue');
    this.titleDocument = new Titledocument();

    this.user = this.authProvider.getUser();
    this.titleProvider.getTitles().subscribe(titles => {

      let arrTitles = [];
      titles.forEach((title) => {
        arrTitles.push(title)
      })

      this.titles = arrTitles;
    })

    this.authProvider.getProof(true).subscribe(_data => {
      console.log('data proof', _data);
      if(_data){
        this.proof = _data;
        this.contractEndDate = this.proof.certificationValidityEnd;
        this.startCountdown();
      }
      
      this.checkFiles(); 
    });

  }

  loadCategories() {
    this.titleProvider.getCategories().subscribe(
      res => {
        if (res) {
          this.categories = res;
          // console.log('Categorias carregadas:', this.categories);
        }
      },
      err => {
        console.error('Erro ao carregar categorias', err);
      }
    );
  }

  setTitle(event): void {
    this.titleId = event.value.id;
  }

  fileOverBase(event): void {
    this.hasBaseDropZoneOver = event;
  }

  getFiles(): FileLikeObject[] {
    return this.fileUploader.queue.map((fileItem) => {
      console.log('getFiles', fileItem.file);
      return fileItem.file;
    });
  }

  ionViewDidLoad() {
    // this.checkFiles();
    this.loadCategories();
    console.log('ionViewDidLoad UpdateRegistrationDocumentPage');
  }

  checkFiles() {
    let loader = this.loadingCtrl.create({
      content: 'Obtendo Arquivos...',
      // duration: 3000
    });
    loader.present();

    this.uploadingprovider.listTitlesFiles(this.user.id).subscribe((response: any) => {
      if (response) {

        if(!this.buttonContinue){

          response.forEach(data =>{
            if(Array.isArray(this.titles)){
              this.titles.forEach(dt=>{
                if(data.titleId == dt.id){
                  data.titleName = dt.name;
                }
              })
            }
          })

          if(this.proof && this.proof.kind !== 'C'){
            this.userFilesGet = response.filter(item =>
              item.documentCategoryId == null &&
              item.documentSubcategoryId == null
            );
          }else{
            this.userFilesGet = response.filter(item =>
              item.documentCategoryId != null &&
              item.documentSubcategoryId != null
            );
          }

        }else{
          let arquivos: any[] = [];

          response.forEach(data => {
            if(Array.isArray(this.titles)){
              this.titles.forEach(dt => {

                if (this.proof && this.proof.kind !== 'C' && data.titleId == dt.id && data.titleId == 18 && data.documentCategoryId == null) {
                  data.titleName = dt.name;
                  arquivos.push(data);
                }else if(this.proof && this.proof.kind == 'C' && data.titleId == dt.id && data.documentCategoryId != null){
                  data.titleName = dt.name;
                  arquivos.push(data);
                }

              });
            }
          });

          this.userFilesGet = arquivos;
        }

        this.userFilesGet.forEach((file) => {
          // if (file.validated === '1' || file.validated === null) {
          this.hasApprovedCertification = true;
          // }
        });

        console.log('listTitlesFiles response ->', this.userFilesGet);
        loader.dismiss();
      }
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      this.alertProvider.doAlert('Houve problemas ao tentar verificar se existem arquivos em anexo.', 'Atenção');
    });

  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onDocumentKindChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('document kind:', event.value);
  }

  onScholarityChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('scholarity:', event.value);
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  doSave() {
    let countFiles = 0;
    this.fileUploader.queue.map((fileItem) => {
      countFiles++;
    });

    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o documento.', 'Atenção');
    } else if (countFiles === 0) {
      this.alertProvider.doAlert('É necessário adicionar um arquivo para upload.', 'Atenção');
    } else if (this.titleId === 0 && !this.buttonContinue) {
      this.alertProvider.doAlert('É necessário selecionar um título para prosseguir.', 'Atenção');
    } else {

      let that = this;
      this.alertProvider.doConfirm('Deseja salvar seu documento?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        let files = this.getFiles();

        if (files.length > 0) {

          files.forEach((file) => {
            let formData = new FormData();
            let userId = this.user.id;
            let titleId = this.buttonContinue ? '18' : this.titleId;
            
            formData.append('file', file.rawFile);
            formData.append('titleId', titleId);
            /*formData.append('proofId', Config.proofId.toString());*/
            //formData.append('validaty', moment(this.titleDocument.validaty, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            this.uploadingprovider.uploadFormTitleData(formData, userId).subscribe((response: any) => {
              if ((response) && (response.updated)) {
                loader.dismiss();
                this.checkFiles();

                this.title = "";
                this.upload.nativeElement.value = "";

                console.log("updateTitleDocument", response);
              }
            });
          });

        }


      });

    }
  }

  removeFile(fileId) {
    this.uploadingprovider.removeTitleFile(fileId).subscribe((response: any) => {
      if ((response) && (response.updated)) {
        //loader.dismiss();
        this.checkFiles();
        console.log("removeTitleFile", response);
      }
    });
  }

  reprovedDescription(msg) {
    this.alertProvider.doAlert(msg, 'Motivo de Reprovação');
  }

  public doContinue(): void {
    console.log(this.userFilesGet.length)
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o documento.', 'Atenção');
    } else if (this.userFilesGet.length < 1) {
      this.alertProvider.doAlert('É necessário adicionar um arquivo para upload.', 'Atenção');
    }else {
      this.navCtrl.push(ProofBeforeBeginPage);
    }
  }

  public goFinishProof(){
    let message: string = 'Você solicitou o encerramento da sua prova.<br /><br />Você tem certeza de que deseja encerrar a prova agora?';

    this.alertProvider.doConfirm(message, () => {
      console.log('usuário finalizou a prova');
      this.menu.enable(true);
      this.menu.swipeEnable(true);

      this.proofProvider.setFinished();
      this.alertProvider.doWaiting('Processando...');

      // TODO: Verify if its using Wifi mode and warn if not
      // DONE: Bug when #popTo direct to ProofListPage
      this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(() => {
        this.events.publish('doProofUpdate');
      });
    });    
  }

  getSubcategoryName(id: number): string {
    if (!this.subcategories || this.subcategories.length === 0) {
      return '';
    }

    const sub = this.subcategories.find(s => s.id === id);
    return sub ? sub.name : '';
  }

  getCategoryName(id: number): string {
    const cat = this.categories.find(c => c.id === id);
    return cat ? cat.name : '';
  }  

  startCountdown() {
    const baseDate = new Date(this.contractEndDate);
    baseDate.setHours(23, 59, 59, 999);

    const end = new Date(this.contractEndDate).getTime();

    this.interval = setInterval(() => {
      const now = new Date().getTime();
      const diff = end - now;

      if (diff <= 0) {
        this.remaining = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        clearInterval(this.interval);
        return;
      }

      this.remaining = {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      };

      const total = end - now;
      const percent = total / (1000 * 60 * 60 * 24 * 7); // baseado em 7 dias (ajustável)

      let colorClass = 'timer-green';
      if (percent < 0.50) colorClass = 'timer-yellow';
      if (percent < 0.20) colorClass = 'timer-red';

      this.remaining.colorClass = colorClass;

    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-title-document/update-title-document.ts